document.addEventListener('click', function (e) {
  const removeButton = e.target.closest('tr[data-product-id="6880269926462"] cart-remove-button, tr[data-product-id="6880269926462"] button.quantity__button[name=minus]');
  if (removeButton) {
    setTimeout(() => {
      document.querySelectorAll('.simply-insurance.widget .switch').forEach(el => el.click());
    }, 800);
  }
});
